/*
 * KDS Header — global navigation controller.
 * Announcement rotator, sticky/scroll state, mega menu, search overlay,
 * account dropdown, mobile drawer, recently-viewed hook. No dependencies.
 */
(function () {
  var root = document.querySelector('.kdsh-root'); if (!root) return;
  if (root.dataset.kdshInit) return; root.dataset.kdshInit = '1';
  var reduce = window.matchMedia && window.matchMedia('(prefers-reduced-motion: reduce)').matches;

  /* ---- Cart count: hide when empty ---- */
  (function () {
    var cc = root.querySelector('[data-cart-count]');
    if (cc) { var v = (cc.textContent || '').trim(); if (v === '' || v === '0') cc.style.display = 'none'; }
  })();

  /* ---- Announcement rotator ---- */
  (function () {
    var slides = root.querySelectorAll('.kdsh-ann__slide');
    if (slides.length < 2) return;
    var i = 0, speed = parseInt(root.getAttribute('data-ann-speed'), 10) || 5;
    if (reduce) return;
    var timer = setInterval(next, speed * 1000);
    function next() {
      slides[i].classList.remove('is-active');
      i = (i + 1) % slides.length;
      slides[i].classList.add('is-active');
    }
    var bar = root.querySelector('.kdsh-ann');
    if (bar) {
      bar.addEventListener('mouseenter', function () { clearInterval(timer); });
      bar.addEventListener('mouseleave', function () { timer = setInterval(next, speed * 1000); });
    }
  })();

  /* ---- Sticky / scroll state ---- */
  (function () {
    var ticking = false;
    function update() { root.classList.toggle('is-scrolled', (window.pageYOffset || document.documentElement.scrollTop) > 20); ticking = false; }
    window.addEventListener('scroll', function () { if (!ticking) { window.requestAnimationFrame(update); ticking = true; } }, { passive: true });
    update();
  })();

  /* ---- Mega menu (hover + keyboard) ---- */
  (function () {
    var items = root.querySelectorAll('[data-mega]');
    var openEl = null;
    function open(it) { if (openEl && openEl !== it) close(openEl); it.classList.add('is-open'); var t = it.querySelector('[data-mega-trigger]'); if (t) t.setAttribute('aria-expanded', 'true'); openEl = it; }
    function close(it) { it.classList.remove('is-open'); var t = it.querySelector('[data-mega-trigger]'); if (t) t.setAttribute('aria-expanded', 'false'); if (openEl === it) openEl = null; }
    items.forEach(function (it) {
      it.addEventListener('mouseenter', function () { open(it); });
      it.addEventListener('mouseleave', function () { close(it); });
      it.addEventListener('focusin', function () { open(it); });
      it.addEventListener('focusout', function (e) { if (!it.contains(e.relatedTarget)) close(it); });
    });
    document.addEventListener('keydown', function (e) { if (e.key === 'Escape' && openEl) close(openEl); });
  })();

  function lock() { document.documentElement.style.overflow = 'hidden'; }
  function unlock() { document.documentElement.style.overflow = ''; }

  /* ---- Search overlay ---- */
  (function () {
    var panel = root.querySelector('[data-kdsh-search]');
    var openBtns = root.querySelectorAll('[data-kdsh-search-open]');
    if (!panel) return;
    var input = panel.querySelector('input[type=search]');
    function open() { panel.classList.add('is-open'); panel.setAttribute('aria-hidden', 'false'); lock(); if (input) setTimeout(function () { input.focus(); }, 60); }
    function close() { panel.classList.remove('is-open'); panel.setAttribute('aria-hidden', 'true'); unlock(); }
    openBtns.forEach(function (b) { b.addEventListener('click', function (e) { e.preventDefault(); open(); }); });
    panel.querySelectorAll('[data-kdsh-close]').forEach(function (b) { b.addEventListener('click', close); });
    panel.addEventListener('click', function (e) { if (e.target === panel) close(); });
    document.addEventListener('keydown', function (e) { if (e.key === 'Escape' && panel.classList.contains('is-open')) close(); });
  })();

  /* ---- Account dropdown ---- */
  (function () {
    var wrap = root.querySelector('[data-kdsh-acct]'); if (!wrap) return;
    var btn = wrap.querySelector('[data-kdsh-acct-btn]');
    var menu = wrap.querySelector('[data-kdsh-acct-menu]');
    if (!btn || !menu) return;
    function open() { wrap.classList.add('is-open'); btn.setAttribute('aria-expanded', 'true'); }
    function close() { wrap.classList.remove('is-open'); btn.setAttribute('aria-expanded', 'false'); }
    btn.addEventListener('click', function (e) { e.preventDefault(); wrap.classList.contains('is-open') ? close() : open(); });
    document.addEventListener('click', function (e) { if (!wrap.contains(e.target)) close(); });
    document.addEventListener('keydown', function (e) { if (e.key === 'Escape') close(); });
  })();

  /* ---- Mobile drawer ---- */
  (function () {
    var drawer = root.querySelector('[data-kdsh-drawer]');
    var openBtn = root.querySelector('[data-kdsh-drawer-open]');
    if (!drawer || !openBtn) return;
    function open() { drawer.classList.add('is-open'); drawer.setAttribute('aria-hidden', 'false'); openBtn.setAttribute('aria-expanded', 'true'); lock(); }
    function close() { drawer.classList.remove('is-open'); drawer.setAttribute('aria-hidden', 'true'); openBtn.setAttribute('aria-expanded', 'false'); unlock(); }
    openBtn.addEventListener('click', open);
    drawer.querySelectorAll('[data-kdsh-close]').forEach(function (b) { b.addEventListener('click', close); });
    drawer.addEventListener('click', function (e) { if (e.target === drawer) close(); });
    document.addEventListener('keydown', function (e) { if (e.key === 'Escape' && drawer.classList.contains('is-open')) close(); });
    drawer.querySelectorAll('[data-kdsh-acc]').forEach(function (acc) {
      var head = acc.querySelector('[data-kdsh-acc-head]');
      if (!head) return;
      head.addEventListener('click', function () { var isOpen = acc.classList.toggle('is-open'); head.setAttribute('aria-expanded', isOpen ? 'true' : 'false'); });
    });
  })();

  /* ---- Recently viewed (extension hook only; not rendered yet) ---- */
  window.KDSRecentlyViewed = window.KDSRecentlyViewed || (function () {
    var KEY = 'kds_recently_viewed_v1', MAX = 12;
    function list() { try { return JSON.parse(localStorage.getItem(KEY) || '[]'); } catch (e) { return []; } }
    function add(handle) { if (!handle) return; var a = list().filter(function (h) { return h !== handle; }); a.unshift(handle); a = a.slice(0, MAX); try { localStorage.setItem(KEY, JSON.stringify(a)); } catch (e) {} }
    return { list: list, add: add, key: KEY };
  })();
})();
